// @flow
import React, { Component } from 'react';
import {
  ConfirmationModalButtons,
  ConfirmationModalDiv,
  ConfirmationModalA,
  ConfirmationModalContentDiv
} from './ModalConductorStyles';
export type ConfirmationModalPayload = {
  title: string,
  message: string,
  onConfirm: () => void,
  onCancel?: () => void,
  confirmText?: string,
  cancelText?: string
};
type Props = {
  closeModal: () => void,
  ...$Exact<ConfirmationModalPayload>
};

export default class ConfirmationModal extends Component<Props> {
  static defaultProps = {
    confirmText: 'Confirm',
    cancelText: 'Cancel'
  };
  cancel = () => {
    this.props.closeModal();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };
  render() {
    return (
      <ConfirmationModalDiv>
        <ConfirmationModalContentDiv>
          <h4>{this.props.title}</h4>
          <p>{this.props.message}</p>
        </ConfirmationModalContentDiv>
        <ConfirmationModalButtons>
          <ConfirmationModalA onClick={this.props.onConfirm}>
            {this.props.confirmText}
          </ConfirmationModalA>
          <ConfirmationModalA onClick={this.cancel}>
            {this.props.cancelText}
          </ConfirmationModalA>
        </ConfirmationModalButtons>
      </ConfirmationModalDiv>
    );
  }
}
